import cx from 'classnames2';
import React from 'react';

import { Checkbox } from '../../Checkbox';
import { useListTableContext } from '../ListTable';

import styles from './ListTable.Header.module.scss';

export interface IListTableHeaderProps {
  checked?: boolean | 'mixed';
  dataTest?: string;
  onSelectAll?(): any;
}

export const ListTableHeader: React.FC<IListTableHeaderProps> = ({ dataTest, checked, onSelectAll, children }) => {
  const listTableContext = useListTableContext();

  return (
    <div className={styles.headerContainer}>
      <div
        className={cx(styles.header, {
          [styles.offsetIcon]: listTableContext.hasIcon,
          [styles.offsetCheckbox]: listTableContext.isSelectable,
          [styles.variantMinimal]: listTableContext.variant === 'minimal'
        })}
        data-test={dataTest}
      >
        {listTableContext.isSelectable ? (
          onSelectAll ? (
            <div className={styles.checkbox}>
              <Checkbox.Small
                checked={checked}
                className={styles.checkboxLabel}
                onChange={() => {
                  onSelectAll();
                }}
              />
            </div>
          ) : (
            <div className={styles.emptyCell} />
          )
        ) : null}
        {listTableContext.hasIcon ? <div className={styles.emptyCell} /> : null}
        {children}
      </div>
    </div>
  );
};
